import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, DrawerStepper } from '@mercai/clever'
import { ProductsIndustryDrawerProps } from './products-industry-drawer.type'
import { ProductsIndustryForm } from './components'
import { LeadProps } from '@/types'

export const ProductsIndustryDrawer = ({
  isOpen,
  onHandleOpen,
  onSubmit,
  isLoading = false,
  values,
}: ProductsIndustryDrawerProps) => {
  const { t } = useTranslation('screenProfileShow')

  const [internalValues, setInternalValues] = useState<Partial<LeadProps>>({
    productOfInterest: values?.productOfInterest,
    industry: values?.industry,
  })

  useEffect(() => {
    setInternalValues({
      productOfInterest: values?.productOfInterest,
      industry: values?.industry,
    })

    return () => {
      setInternalValues({})
    }
  }, [values])

  return (
    <DrawerStepper
      translations={{
        optional: '',
      }}
      isOpen={isOpen}
      onHandleOpen={onHandleOpen}
      title={t('productsIndustryDrawerTitle')}
      initialStep="root"
      steps={{
        root: {
          isOptional: true,
          backNavigate: 'root',
          component: (
            <ProductsIndustryForm
              values={internalValues}
              onValuesChange={setInternalValues}
            />
          ),
          footer: () => (
            <>
              <Button variant="secondary" onClick={onHandleOpen}>
                {t('backLabel')}
              </Button>
              <Button
                onClick={() => onSubmit?.(internalValues)}
                isActive={!isLoading}
                disabled={isLoading}
              >
                {t('confirmLabel')}
              </Button>
            </>
          ),
        },
      }}
    />
  )
}
